<template>
  <div>
    <hnavbar />
    <Content pagetitle="WASSCE APPLICATION">
      <form role="form" @submit.prevent="submitAndProceed">
        <box boxheading="PERSONAL INFORMATION">
          <div class="box-body">
            <div class="row">
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="name"
                    >Name of Applicant <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="name"
                    name="name"
                    v-model="formdata.name"
                    placeholder="Enter Name"
                    v-validate="'required'"
                    data-vv-as="Name"
                  />
                </div>
                <span class="text-danger text-sm" v-show="errors.has('name')">{{
                  errors.first("name")
                }}</span>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="email"
                    >Email <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="email"
                    name="email"
                    v-model="formdata.email"
                    placeholder="Email"
                    v-validate="'required'"
                    data-vv-as="Email"
                  />
                </div>
                <span class="text-danger text-sm" v-show="errors.has('email')">
                  {{ errors.first("email") }}
                </span>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="phone"
                    >Phone <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="phone"
                    name="phone"
                    v-model="formdata.phone"
                    placeholder="Phone"
                    v-validate="'required'"
                    data-vv-as="Phone"
                  />
                </div>
                <span class="text-danger text-sm" v-show="errors.has('phone')">
                  {{ errors.first("phone") }}
                </span>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="dob"
                    >Date of Birth <span style="color: red">*</span></label
                  >
                  <input
                    type="date"
                    class="form-control"
                    id="dob"
                    name="dob"
                    v-model="formdata.dob"
                    v-validate="'required'"
                    data-vv-as="Date of Birth"
                  />
                </div>
                <span class="text-danger text-sm" v-show="errors.has('dob')">{{
                  errors.first("dob")
                }}</span>
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="lastschool"
                    >Last School Attended
                    <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="lastschool"
                    name="lastschool"
                    v-model="formdata.lastschool"
                    v-validate="'required'"
                    data-vv-as="Last School Attended"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('lastschool')"
                  >{{ errors.first("lastschool") }}</span
                >
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="address"
                    >Postal Address <span style="color: red">*</span></label
                  >
                  <textarea
                    class="form-control"
                    name="postaladdress"
                    rows="4"
                    cols="10"
                    v-model="formdata.postaladdress"
                    v-validate="'required'"
                    data-vv-as="Postal Address"
                  ></textarea>
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('postaladdress')"
                  >{{ errors.first("postaladdress") }}</span
                >
              </div>
              <div class="col-sm-4">
                <div class="form-group">
                  <label for="certobtained"
                    >Name of Certificate Obtained
                    <span style="color: red">*</span></label
                  >
                  <input
                    type="text"
                    class="form-control"
                    id="certobtained"
                    name="certobtained"
                    v-model="formdata.certobtained"
                    v-validate="'required'"
                    data-vv-as="Certificate Obtained"
                  />
                </div>
                <span
                  class="text-danger text-sm"
                  v-show="errors.has('certobtained')"
                  >{{ errors.first("certobtained") }}</span
                >
              </div>
            </div>
          </div>
        </box>
        <box
          boxheading="Subjects and grades obtained applicable to only basic and second cycle students,if not,escape it."
        >
          <div
            class="row"
            v-for="(i, index) in formdata.subjects"
            :key="index"
            style="border-bottom: 1px solid #ddd; margin: 15px 0px"
          >
            <div class="col-sm-6">
              <div class="form-group">
                <label for="subject">Subject</label>
                <select
                  class="form-control"
                  id="subject"
                  name="subject"
                  v-validate="'required'"
                  data-vv-as="Waec Subject"
                  v-model="formdata['subject' + i]"
                >
                  <option value="">Choose Subject</option>
                  <option value="ACCOUNTING">ACCOUNTING</option>
                  <option value="AGRIC.SC.& EVN.STUDS (CORE)">
                    AGRIC.SC.& EVN.STUDS (CORE)
                  </option>
                  <option value="ANIMAL HUSBANDRY">ANIMAL HUSBANDRY</option>
                  <option value="APPLIED ELECTRICITY">
                    APPLIED ELECTRICITY
                  </option>
                  <option value="ARABIC">ARABIC</option>
                  <option value="AUTO MECHANICS">AUTO MECHANICS</option>
                  <option value="BASKETRY">BASKETRY</option>
                  <option value="BIOLOGY">BIOLOGY</option>
                  <option value="BUILDING CONSTRUCTION">
                    BUILDING CONSTRUCTION
                  </option>
                  <option value="BUS MATHS AND PRINC OF COSTING">
                    BUS MATHS AND PRINC OF COSTING
                  </option>
                  <option value="BUSINESS MANAGEMENT">
                    BUSINESS MANAGEMENT
                  </option>
                  <option value="CERAMICS">CERAMICS</option>
                  <option value="CHEMISTRY">CHEMISTRY</option>
                  <option value="CHRISTIAN REL.STUDIES">
                    CHRISTIAN REL.STUDIES
                  </option>
                  <option value="CLERICAL & OFFICE DUTIES">
                    CLERICAL & OFFICE DUTIES
                  </option>
                  <option value="CLOTHING & TEXTILES">
                    CLOTHING & TEXTILES
                  </option>
                  <option value="CROP HUSB.& HORTICULTURE">
                    CROP HUSB.& HORTICULTURE
                  </option>
                  <option value="DAGAARE">DAGAARE</option>
                  <option value="DAGBANI">DAGBANI</option>
                  <option value="DANGME">DANGME</option>
                  <option value="ECONOMICS">ECONOMICS</option>
                  <option value="ELECTRONICS">ELECTRONICS</option>
                  <option value="ENGLISH LANGUAGE (CORE)">
                    ENGLISH LANGUAGE (CORE)
                  </option>
                  <option value="EWE">EWE</option>
                  <option value="EWE (CORE)">EWE (CORE)</option>
                  <option value="FANTE">FANTE</option>
                  <option value="FINANCIAL ACCOUNTING">
                    FINANCIAL ACCOUNTING
                  </option>
                  <option value="FISHERIES">FISHERIES</option>
                  <option value="FOOD & NUTRITION">FOOD & NUTRITION</option>
                  <option value="FORESTRY">FORESTRY</option>
                  <option value="FRENCH">FRENCH</option>
                  <option value="GA">GA</option>
                  <option value="GA (CORE)">GA (CORE)</option>
                  <option value="GEN.KNOW.IN ART">GEN.KNOW.IN ART</option>
                  <option value="GENERAL AGRICULTURE">
                    GENERAL AGRICULTURE
                  </option>
                  <option value="GEOGRAPHY">GEOGRAPHY</option>
                  <option value="GONJA">GONJA</option>
                  <option value="GOVERNMENT">GOVERNMENT</option>
                  <option value="GRAPHIC DESIGN">GRAPHIC DESIGN</option>
                  <option value="HISTORY">HISTORY</option>
                  <option value="INFO. & COMM. TECHNOLOGY">
                    INFO. & COMM. TECHNOLOGY
                  </option>
                  <option value="INTEGRATED SCIENCE (CORE)">
                    INTEGRATED SCIENCE (CORE)
                  </option>
                  <option value="INTRO.TO BUS.MANAGEMENT">
                    INTRO.TO BUS.MANAGEMENT
                  </option>
                  <option value="ISLAMIC REL.STUDIES">
                    ISLAMIC REL.STUDIES
                  </option>
                  <option value="JEWELLERY">JEWELLERY</option>
                  <option value="KASEM">KASEM</option>
                  <option value="LEATHERWORK">LEATHERWORK</option>
                  <option value="LIFE SKILLS (CORE)">LIFE SKILLS (CORE)</option>
                  <option value="LITERATURE IN ENGLISH">
                    LITERATURE IN ENGLISH
                  </option>
                  <option value="MANAGEMENT IN LIVING">
                    MANAGEMENT IN LIVING
                  </option>
                  <option value="MATHEMATICS">MATHEMATICS</option>
                  <option value="MATHEMATICS (CORE)">MATHEMATICS (CORE)</option>
                  <option value="METAL WORK">METAL WORK</option>
                  <option value="MUSIC">MUSIC</option>
                  <option value="NZEMA">NZEMA</option>
                  <option value="PHYSICS">PHYSICS</option>
                  <option value="PICTURE MAKING">PICTURE MAKING</option>
                  <option value="PRIN OF COST ACCOUNTING">
                    PRIN OF COST ACCOUNTING
                  </option>
                  <option value="SCULPTURE">SCULPTURE</option>
                  <option value="SOCIAL STUDIES(CORE)">
                    SOCIAL STUDIES(CORE)
                  </option>
                  <option value="TECH.DRAW & ENG.SCIENCE">
                    TECH.DRAW & ENG.SCIENCE
                  </option>
                  <option value="TEXTILES">TEXTILES</option>
                  <option value="TWI-AKWAPIM<">TWI-AKWAPIM</option>
                  <option value="TWI-AKWAPIM (CORE)">TWI-AKWAPIM (CORE)</option>
                  <option value="TWI-ASANTE">TWI-ASANTE</option>
                  <option value="TYPEWRITING (40 W.P.M.)">
                    TYPEWRITING (40 W.P.M.)
                  </option>
                  <option value="WOODWORK">WOODWORK</option>
                </select>
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('subject')"
                >{{ errors.first("subject") }}</span
              >
            </div>
            <div class="col-sm-6">
              <div class="form-group">
                <label for="grades">Grades</label>
                <select
                  class="form-control"
                  v-validate="'required'"
                  data-vv-as="Grades"
                  name="grade"
                  v-model="formdata['grade' + i]"
                >
                  <option value="">Choose Grade</option>
                  <option value="A1">A1</option>
                  <option value="B2">B2</option>
                  <option value="B3">B3</option>
                  <option value="C4">C4</option>
                  <option value="C5">C5</option>
                  <option value="C6">C6</option>
                  <option value="D7">D7</option>
                  <option value="E8">E8</option>
                  <option value="F9">F9</option>
                  <option value="A">A</option>
                  <option value="B">B</option>
                  <option value="C">C</option>
                  <option value="D">D</option>
                  <option value="E">E</option>
                  <option value="F">F</option>
                  <option value="X">X</option>
                  <option value="Y">Y</option>
                  <option value="-">-</option>
                </select>
              </div>
              <span class="text-danger text-sm" v-show="errors.has('grade')">{{
                errors.first("grade")
              }}</span>
            </div>
          </div>
          <button
            type="button"
            class="btn btn-sm btn-primary"
            @click="formdata.subjects++"
          >
            Add More 
          </button>
          &nbsp;&nbsp;
          <button
            type="button"
            class="btn btn-sm btn-danger"
            @click="formdata.subjects--"
            v-if="formdata.subjects > 1"
          >
            Remove
          </button>
        </box>
        <box boxheading="PROBLEMATIC SUBJECT(S): Please specify">
          <div class="row">
            <div class="col-sm-6">
              <div class="form-group">
                <label for="problemsubject"
                  >Specify(Enter Subject Line by Line)</label
                >
                <textarea
                  class="form-control"
                  name="problemsubject"
                  v-model="formdata.problemsubject"
                  v-validate="'required'"
                  data-vv-as="Problematic Subject(s)"
                  rows="8"
                  cols="10"
                ></textarea>
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('problemsubject')"
                >{{ errors.first("problemsubject") }}</span
              >
            </div>
          </div>
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="counselling">Do you need special counseling</label>
                <select
                  name="counselling"
                  id="counselling"
                  class="form-control"
                  v-model="formdata.counselling"
                >
                  <option value="">Please select</option>
                  <option value="Yes">Yes</option>
                  <option value="No">No</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gettoknow"
                  >How did you get to know the school</label
                >
                <select
                  name="gettoknow"
                  id="gettoknow"
                  class="form-control"
                  v-model="formdata.gettoknow"
                >
                  <option value="">Please select</option>
                  <option value="Poster">Poster</option>
                  <option value="Friends">Friends</option>
                  <option value="Radio Adverts">Radio Adverts</option>
                  <option value="Other">Other</option>
                </select>
              </div>
            </div>
            <div class="col-sm-4" v-if="formdata.gettoknow === 'Other'">
              <div class="form-group">
                <label for="gettoknow">Please Specify</label>
                <input
                  type="text"
                  class="form-control"
                  name="gettoknowspecify"
                  v-model="formdata.gettoknowspecify"
                />
              </div>
            </div>
          </div>
        </box>
        <box boxheading="Number of Subjects Registering for:">
          <div class="row">
            <div class="col-sm-6">
              <label for="registering"
                >Number of Subjects Registering(You can select multiple
                Subjects)</label
              >
              <v-select
                taggable
                multiple
                :options="subjects"
                name="registering"
                v-model="formdata.registering"
              ></v-select>
            </div>
          </div>
        </box>

        <box boxheading="Payments">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="amount"
                  >Total Amount due for payment
                  <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="amount"
                  name="amount"
                  v-model="formdata.amount"
                  v-validate="'required'"
                  data-vv-as="Amount"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('amount')">{{
                errors.first("amount")
              }}</span>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="contactofpaying"
                  >Contact of paying party
                  <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="contactofpaying"
                  name="contactofpaying"
                  v-model="formdata.contactofpaying"
                  v-validate="'required'"
                  data-vv-as="Paying Party"
                />
              </div>
              <span
                class="text-danger text-sm"
                v-show="errors.has('contactofpaying')"
                >{{ errors.first("contactofpaying") }}</span
              >
            </div>
          </div>
        </box>
        <box boxheading="GUARANTOR INFORMATION">
          <div class="row">
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gname"
                  >Guarantor Name <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="gname"
                  name="gname"
                  v-validate="'required'"
                  data-vv-as="Guarantor Name"
                  v-model="formdata.gname"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('gname')">{{
                errors.first("gname")
              }}</span>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gphone"
                  >Guarantor Phone <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="gphone"
                  name="gphone"
                  data-vv-as="Guarantor Phone"
                  v-validate="'required'"
                  v-model="formdata.gphone"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('gphone')">{{
                errors.first("gphone")
              }}</span>
            </div>
            <div class="col-sm-4">
              <div class="form-group">
                <label for="gemail"
                  >Guarantor Email <span style="color: red">*</span></label
                >
                <input
                  type="text"
                  class="form-control"
                  id="gemail"
                  name="gemail"
                  data-vv-as="Guarantor Email"
                  v-validate="'required'"
                  v-model="formdata.gemail"
                />
              </div>
              <span class="text-danger text-sm" v-show="errors.has('gemail')">{{
                errors.first("gemail")
              }}</span>
            </div>
          </div>
        </box>
        <div class="box-footer center" style="display: block; margin: auto">
          <button type="submit" class="btn btn-primary btn-lg">Submit</button>
        </div>
      </form>
    </Content>
    <BlockUI :message="msg" v-if="blockui"></BlockUI>
  </div>
</template>

<script>
import hnavbar from "../components/HNavBar.vue";
import Content from "../components/Content.vue";
import Box from "../components/Box.vue";
export default {
  name: "Wassce",
  components: {
    hnavbar,
    Content,
    Box,
  },
  data() {
    return {
      msg: "Please wait",
      blockui: false,
      subjects: [
        "ACCOUNTING",
        "BIOLOGY",
        "ENGLISH LANGUAGE (CORE)",
        "MATHEMATICS (CORE)",
        "FRENCH",
        "GOVERNMENT",
        "HISTORY",
        "INTEGRATED SCIENCE (CORE)",
        "ELECTIVE MATHEMATICS",
        "PHYSICS",
        "CHEMISTRY",
        "ECONOMICS",
        "BUSINESS MANAGEMENT",
        "GEN.KNOW.IN ART",
        "INFO. & COMM. TECHNOLOGY",
        "BUS MATHS AND PRINC OF COSTING",
        "GEOGRAPHY",
      ],
      formdata: {
        subjects: 1,
        name: "",
        dob: "",
        email: "",
        phone: "",
        lastschool: "",
        postaladdress: "",
        certobtained: "",
        problemsubject: "",
        counselling: "",
        registering: [],
        amount: "",
        contactofpaying: "",
        gettoknow: "",
        gettoknowspecify: "",
        gname: "",
        gphone: "",
        gemail: "",
      },
    };
  },
  methods:{
    submitAndProceed() {
      this.$validator
        .validateAll()
        .then((valid) => {
          if (valid) {
            this.blockui = true;
            console.log(this.formdata);
            this.axios
              .post(this.appenv.baseurl + "/wassce", this.formdata)
              .then((response) => {
                console.log(response.data);
                this.blockui = false;
                if (response.data && response.data.status === "success") {
                  this.$router.push("/complete");
                } else {
                  this.$alert(
                    "Ooops.. Processing failed. Please try again",
                    "Alert",
                    "error"
                  );
                }
              })
              .catch(() => {
                this.blockui = false;
                this.$alert(
                  "Ooops.. Processing failed. Please try again",
                  "Alert",
                  "error"
                );
              });
          }
        })
        .catch(() => {
          this.blockui = false;
        });
    },
  }
};
</script>

<style lang="scss" scoped></style>
